import { MatSnackBar, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ChatNotificationComponent } from './chat-notification.component';
import { ChatNotificationSoundService } from './chat-notification-sound.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Subscription, from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { RealtimeService } from 'src/app/services/realtime/realtime.service';
import { RepairsService } from 'src/app/services/api/loggedServices/repairs/repairs.service';

@Component({
  selector: 'app-realtime-inbox', standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, MatButtonModule, MatMenuModule, MatBadgeModule, MatTooltipModule, TablerIconsModule, MatSnackBarModule],
  templateUrl: './realtime-inbox.component.html',
  styleUrl: './realtime-inbox.component.scss'
})
export class RealtimeInboxComponent implements OnInit, OnDestroy {
  readonly repairRoute = '/management/repairs/details';
  entries: { uuid: string; count: number }[] = [];
  total = 0;
  labels: Record<string, string> = {};
  private alerts?: Subscription;
  private notice?: MatSnackBarRef<ChatNotificationComponent>;
  private opened = false;
  private unread?: Subscription;
  private details?: Subscription;
  constructor(public realtime: RealtimeService, private repairs: RepairsService, public sound: ChatNotificationSoundService, private snackbar: MatSnackBar, private translate: TranslateService) { }
  ngOnInit(): void {
    this.sound.listen();
    this.alerts = this.realtime.notifications$.subscribe(event => {
      const chat = document.querySelector<HTMLElement>('app-repair-chat');
      const bounds = chat?.getBoundingClientRect();
      const reading = document.visibilityState === 'visible' && document.hasFocus()
        && chat?.dataset['repairUuid'] === event.conversationUuid && bounds && bounds.top < innerHeight && bounds.bottom > 0;
      if (reading) return;
      this.notice = this.snackbar.openFromComponent(ChatNotificationComponent, {
        data: { uuid: event.conversationUuid, route: this.repairRoute, label: this.labels[event.conversationUuid] || '' },
        panelClass: 'chat-toast', duration: 6500, horizontalPosition: 'right', verticalPosition: 'top',
        announcementMessage: this.translate.instant('realtime.newMessage')
      });
      this.sound.play();
    });
    this.realtime.start();
    this.unread = this.realtime.unread$.subscribe(counts => {
      this.entries = Object.entries(counts).filter(([, count]) => count > 0).map(([uuid, count]) => ({ uuid, count }));
      this.total = this.entries.reduce((sum, entry) => sum + entry.count, 0);
      if (this.opened) this.loadLabels();
    });
  }
  open(): void { this.opened = true; this.loadLabels(); }
  close(): void { this.opened = false; }
  private loadLabels(): void {
    this.details?.unsubscribe();
    // Only resolve repair names while the user is looking at the inbox; limit parallel requests.
    this.details = from(this.entries.filter(entry => !this.labels[entry.uuid])).pipe(
      mergeMap(entry => this.repairs.getRepairDetails(entry.uuid).pipe(
        map((repair: any) => ({ uuid: entry.uuid, label: repair.identifier || '' })),
        catchError(() => of({ uuid: entry.uuid, label: '' }))
      ), 4)
    ).subscribe(({ uuid, label }) => { if (label) this.labels = { ...this.labels, [uuid]: label }; });
  }
  ngOnDestroy(): void { this.alerts?.unsubscribe(); this.notice?.dismiss(); this.sound.stop(); this.unread?.unsubscribe(); this.details?.unsubscribe(); this.realtime.stop(); }
}
